(function() {
    'use strict';

    angular
        .module('functional7App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ejercicio', {
            parent: 'entity',
            url: '/ejercicio',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'functional7App.ejercicio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ejercicio/ejercicios.html',
                    controller: 'EjercicioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ejercicio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ejercicio-detail', {
            parent: 'ejercicio',
            url: '/ejercicio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'functional7App.ejercicio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ejercicio/ejercicio-detail.html',
                    controller: 'EjercicioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ejercicio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ejercicio', function($stateParams, Ejercicio) {
                    return Ejercicio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ejercicio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ejercicio-detail.edit', {
            parent: 'ejercicio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ejercicio/ejercicio-dialog.html',
                    controller: 'EjercicioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ejercicio', function(Ejercicio) {
                            return Ejercicio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ejercicio.new', {
            parent: 'ejercicio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ejercicio/ejercicio-dialog.html',
                    controller: 'EjercicioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ejercicio', null, { reload: 'ejercicio' });
                }, function() {
                    $state.go('ejercicio');
                });
            }]
        })
        .state('ejercicio.new.media', {
            parent: 'ejercicio',
            url: '/newmedia',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media/media-dialog_2.html',
                    controller: 'MediaDialogController2',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                mineType: null,
                                nombreFichero: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ejercicio.edit', {
            parent: 'ejercicio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ejercicio/ejercicio-dialog.html',
                    controller: 'EjercicioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ejercicio', function(Ejercicio) {
                            return Ejercicio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ejercicio', null, { reload: 'ejercicio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ejercicio.delete', {
            parent: 'ejercicio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ejercicio/ejercicio-delete-dialog.html',
                    controller: 'EjercicioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ejercicio', function(Ejercicio) {
                            return Ejercicio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ejercicio', null, { reload: 'ejercicio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
